import { Skeleton } from 'ui/skeleton';

export const AffinityTrendsSkeletonId = 'affinity-trends-skeleton';

export const AffinityTrendsSkeleton = () => {
  return (
    <>
      <Skeleton data-test={AffinityTrendsSkeletonId} width={730} height={360} />
      <Skeleton width={410} height={360} />
    </>
  );
};
